module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/cowork-1-49be425aa815d0a38134cf1b98f3849b.jpg";